import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { uploadKYCDocument } from '@/services/api';

export function ProfileDocumentsPage() {
  const { profile } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function handleFileUpload(e: React.ChangeEvent<HTMLInputElement>) {
    if (!profile) return;
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setError(null);
    setMessage(null);

    try {
      await uploadKYCDocument(file, profile.id);
      setMessage(`Datei "${file.name}" erfolgreich hochgeladen.`);
      e.target.value = '';
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Upload fehlgeschlagen.');
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">KYC-Dokumente</h1>

      <div className="p-4 border border-surface-border rounded-sm">
        <h2 className="text-lg font-serif mb-2">Dokumente hochladen</h2>
        <p className="text-text-secondary text-sm mb-4">
          Bitte laden Sie einen Handelsregisterauszug und ggf. eine Ausweiskopie hoch.
          Zulassig: PDF, JPEG, PNG (max. 10 MB).
        </p>

        <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileUpload} className="block mb-4" />

        {uploading && <p className="text-sm text-text-secondary">Wird hochgeladen...</p>}
        {message && <p className="text-sm text-status-success">{message}</p>}
        {error && <p className="text-sm text-status-danger">{error}</p>}
      </div>
    </div>
  );
}
